import AxiosClient from "../AxiosClient";

export const getCommodityOwner = (params) => {
  const url = "/api/commodityOwner/searchShortInfoList";
  return AxiosClient.post(url, params);
};

export const getCommodityOwnerInfo = (params) => {
  const url = "/api/commodityOwner/searchInfoList";
  return AxiosClient.post(url, params);
};

export const insertCommodityOwner = (params) => {
  const url = "/api/commodityOwner/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateCommodityOwner = (params) => {
  const url = "/api/commodityOwner/updateInfo";
  return AxiosClient.post(url, params);
};

export const deleteCommodityOwner = (params) => {
  const url = "/api/commodityOwner/deleteInfo";
  return AxiosClient.post(url, params);
};
export const downloadCommodityOwnerPrintInfo = (requestBody = {}) => {
  const url = `/api/commodityOwner/printInfoList`;
  return AxiosClient.post(url, requestBody, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error("Error:", error);
    });
};